import { Capacitor } from '@capacitor/core';
import { SavePassword } from '@capgo/capacitor-autofill-save-password';

// The account last taken from the saved-password sheet. It is already saved, and Android
// offers to save it again anyway, so signing in with it skips the prompt.
let picked: { username: string; password: string } | null = null;

// Ask the OS password manager (iCloud Keychain / Google Password Manager) to save the
// credentials after a successful login or sign-up. `url` must be one of the webcredentials:
// associated domains in the iOS entitlements; VITE_API_URL is this flavor's web host.
// A dismissed prompt rejects — that is not an error worth surfacing.
export const promptSaveCredentials = async (username: string, password: string) => {
  // Empty after the OAuth → 2FA redirect, where no password was typed.
  if (!Capacitor.isNativePlatform() || !username || !password) return;
  if (username === picked?.username && password === picked.password) return;
  try {
    await SavePassword.promptDialog({
      username,
      password,
      url: new URL(import.meta.env.VITE_API_URL).hostname,
    });
  } catch (err) {
    console.warn('Save password prompt not completed:', err);
  }
};

// The OS sheet of accounts saved for the app: Credential Manager on Android, whose WebView
// runs on https://localhost so Google autofill finds nothing; on iOS the webcredentials:
// domains' iCloud Keychain entries, which does not depend on the WebView origin.
// Null when nothing is saved or the sheet is dismissed.
export const pickSavedCredentials = async () => {
  if (!Capacitor.isNativePlatform()) return null;
  try {
    picked = await SavePassword.readPassword();
    return picked;
  } catch {
    return null;
  }
};
